import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EmptyAnnotationToolFilter, FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const AnnotationToolsHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const handleClear = (): void => {
    props.onSetAnnotationTools([{ ...EmptyAnnotationToolFilter }]);
  };

  const isSelected = props.activeFilterType === FilterTabType.AnnotationTools;
  const count = props.imageFilters.annotationTools.filter((x) => x.l1FilterType !== undefined).length;

  return (
    <FilterHeader
      filterType={FilterTabType.AnnotationTools}
      isSelected={isSelected}
      labelKey='annotation_tools'
      count={count}
      showClear={count > 0}
      onClear={handleClear}
      onSelect={props.onFilterTabSelect}
    />
  );
});
